<template>
  <b-container>
    <div>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </div>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="xl"
      @hide="hide"
      :title="$t('checklist.template.templateCreate')"
    >
      <export-template-csv-crud
        :model="model"
        :editing="false"
      ></export-template-csv-crud>

      <!-- {{ model }} -->

      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button variant="green" @click="save" :disabled="canSubmit">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "ExportTemplateCsvCreateModal",
  components: {
    ExportTemplateCsvCrud: () =>
      import(
        "@/components_rms/checklist/ExportTemplateCsv/ExportTemplateCsvCrud.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Template criado com sucesso",
      },
      model: {
        templateName: "",
        formId: 0,
        active: true,
        fields: [],
      },
      canSubmit: false,
    };
  },
  methods: {
    show() {
      this.$refs.openModal.show();
    },
    save() {
      this.canSubmit = true;
      this.$apiChecklist
        .post("/exportTemplateCsv/create/", this.model)
        .then((response) => {
          this.canSubmit = false;
          this.$refs.openModal.hide();
          this.$emit("refresh");
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.canSubmit = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(error.response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    hide() {
      this.model.templateName = "";
      this.model.formId = 0;
      this.model.active = true;
      this.model.fields = [];
      this.$refs.openModal.hide();
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>